var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTensotribunas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1110.49 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9d9d9d;}.cls-2{fill:#b8b8b7;}.cls-3{isolation:isolate;}.cls-4{fill:#e2e2e2;mix-blend-mode:multiply;}.cls-5{fill:#cfcfcf;}.cls-6{clip-path:url(#clippath-1);}.cls-7{fill:#89b8e3;}.cls-8{fill:#58b9e9;}.cls-9{fill:none;}.cls-10{fill:#9c9b9b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 540,
    cy: 540.78,
    r: 432.74
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 540,
    cy: 540.78,
    r: 432.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "561.91 342.76 204.25 551.72 307.38 611.24 561.91 462.56 561.91 342.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "561.91 543.27 307.38 691.99 401.47 746.28 561.91 652.55 561.91 543.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "561.91 730.64 401.48 824.38 498.28 881.74 561.91 844.57 561.91 730.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "561.91 263.43 204.25 472.4 204.25 551.72 561.91 342.76 561.91 263.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "561.91 462.67 307.38 611.24 307.38 691.99 561.91 543.27 561.91 462.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "561.91 652.56 401.47 746.3 401.48 824.38 561.91 730.64 561.91 652.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "561.91 844.56 498.28 881.74 498.28 961.06 561.91 923.88 561.91 844.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M561.91,296.19l-8.73,5.06c-4.32,2.5-6.98,7.11-6.98,12.1v55.52c0,11.45,5.98,22.02,15.71,27.98v-100.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M561.91,217.2l-19.08-11.19c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l51.5-29.83v-20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M561.91,486.7l-54.53,31.59c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.03l2.4-1.39v-143.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M524.52,450.55l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M429.63,304.42l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M561.91,788.15l-4.19-2.46c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l36.61-21.21v-38.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M478.72,667.59l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.83,532.85l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.94,386.72l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "582.65 110.12 82.66 402.24 204.25 472.4 742.21 158.09 704.16 140.26 591.56 111.08 582.65 110.12"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "498.28 962.47 82.66 735.6 82.66 402.24 204.25 472.4 204.25 551.72 307.38 611.24 307.38 691.99 401.47 746.28 401.48 824.38 498.28 881.74 498.28 962.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "204.25 551.72 307.38 611.24 919.65 253.6 816.45 194.05 204.25 551.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "307.38 691.99 401.47 746.28 1013.68 388.6 919.59 334.31 307.38 691.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "401.48 824.38 498.28 881.74 1110.49 524.06 1013.69 466.7 401.48 824.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "204.25 472.4 816.45 114.72 816.45 194.05 204.25 551.72 204.25 472.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "307.38 611.24 919.59 253.9 919.59 334.31 307.38 691.99 307.38 611.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "401.47 746.3 1013.68 388.6 1013.69 466.7 401.48 824.38 401.47 746.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "498.28 881.74 1110.49 524.06 1110.49 603.38 498.28 962.47 498.28 881.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1007.24,554.91l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M900.77,420.7l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M805.88,285.96l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M710.99,139.83l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28V43.73c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.56,637.2l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M760.09,503l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.2,368.26l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.31,222.13l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.88,719.5l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.41,585.3l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.52,450.55l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.63,304.42l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.2,801.8l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.72,667.59l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.83,532.85l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.94,386.72l-27.48-16.11c-9.33-5.47-15.06-15.47-15.06-26.28v-53.71c0-4.96-5.37-8.06-9.66-5.57l-59.82,34.66c-4.32,2.5-6.98,7.11-6.98,12.1v55.53c0,11.68,6.2,22.48,16.29,28.37l28.75,16.79c4.34,2.54,9.71,2.55,14.07,.02l59.87-34.68c4.27-2.47,4.28-8.63,.03-11.12Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0,
    width: 1080,
    height: 1080
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensotribunas);
export default __webpack_public_path__ + "static/media/tensotribunas.4209a92121e864de959caa3fb1015c66.svg";
export { ForwardRef as ReactComponent };